<template>
  <div id="filter">
    <b-container fluid>
      <b-row>
        <!-- PAGE TITLE -->
        <b-col cols="12 space-b2 space-t2 border-b">
          <h1 class="serif-m">
            Digital Participatory Knowledge <br />
            Practices in Analogue <br />
            and Digital Image Archives
          </h1>
          <!-- <p>{{$store.state.filter}}</p> -->
        </b-col>

        <!-- SEARCH INPUT -->
        <!-- <input
          v-model="searchTerm"
          v-on:keyup.enter="searchFuntion(searchTerm)"
          type="text"
          placeholder="Search"
        /> -->

        <!-- FILTER TITLE -->
        <!-- <b-col cols="12" id="filter-title" class="border-b space-b2 space-t2">
          <p>Filter</p>
          <img src="icons/close.svg"
            @click="resetBtns();"
            :class="{ 'd-none': !filterResults.filtered }"
          >
        </b-col> -->

        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Suche</p>
          <ClassicSearch></ClassicSearch>
        </b-col>

        <!-- COLLECTIONS -->
        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Sammlungen</p>
          <button
            v-for="(collection, i) in collections"
            :key="'collection-' + i"
            @click="filterCollection(collection)"
            class="button-block"
            :class="{ active: $store.state.filter.collection.includes(collection) }">
            {{ collection|capitalize }}
          </button>
        </b-col>


        <!-- TYPES -->
        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Typen</p>
          <button
            v-for="(typ, i) in typen"
            :key="'typ-' + i"
            @click="filterTyp(typ)"
            class="button-block"
            :class="{ active: $store.state.filter.typ.includes(typ) }">
            {{ typ|capitalize }}
          </button>
        </b-col>

        <!-- SUBPROJECTS -->
        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Subprojects</p>
          <button
            v-for="(subproject, i) in subprojects"
            :key="'subproject-' + i"
            @click="filterSubproject(subproject)"
            :class="{ active: $store.state.filter.subproject.includes(subproject) }">
            {{ subproject|capitalize }}
          </button>
        </b-col>

        <!-- AUTHOR -->
        <!-- <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Authors</p>
          <button
            v-for="(author, i) in authors"
            :key="'author-' + i"
            @click="filterAuthor(author)"
            class="button-block"
            :class="{ active: $store.state.filter.author.includes(author) }">
            {{ author|capitalize }}
          </button>
        </b-col> -->

        <!-- RESPONSIBLES -->
        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Eintragsverantwortliche</p>
          <button
            v-for="(responsible, i) in responsibles"
            :key="'responsible-' + i"
            @click="filterResponsible(responsible)"
            class="button-block"
            :class="{ active: $store.state.filter.responsible.includes(responsible) }">
            {{ responsible|capitalize }}
          </button>
        </b-col>

        

        <!-- TAGS -->
        <b-col cols="12" class="space-b2 space-t2 border-b">
          <p class="sans-s space-b1">Tags</p>
          <button
            v-for="(tag, i) in tags"
            :key="'tag-' + i"
            @click="filterTag(tag)"
            class="button-block"
            :class="{ active: $store.state.filter.tag.includes(tag) }">
            {{ tag|capitalize }}
          </button>
        </b-col>


      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ClassicSearch from "@/components/ClassicSearch";

export default {
  name: 'FilterNav',
  components: {
    ClassicSearch
  },
  data() {
    return {
      searchTerm: "",
    };
  },
  methods: {
    // import all the actions from store, they handle data asynchonous
    ...mapActions([
			// the function to filter for subprojects
      "filterCollection",
      "filterTyp",
			"filterSubproject",
			"filterAuthor",
			"filterResponsible",
      "filterTag",
		]),
  },
  computed: {
    ...mapGetters([
      // get the computed subprojects to create the buttons
      "collections",
      "typen", 
      "subprojects",
      "authors",
      "responsibles",
      "tags"
    ]),
  },
};
</script>

<style lang="scss" scoped>

#filter {
  background-color: #1d1d1d;
  min-height: 100vh;
  height: 100%;
}

h1 {
  // color: #8d8d8d;
  line-height: 2.4rem !important;
  color: white;
}

p {
  color: white;
}

input[type="text"] {
  background-color: #1d1d1d;
  width: 100%;
  border: none;
  outline: none;
  color: white;
  opacity: 1;
  margin: 0;
  padding-left: 1.5rem;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  border-top: 0.1rem solid white;
  border-bottom: 0.1rem solid white;
  &:focus {
    outline: none;
  }
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: white;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: white;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: white;
}

#filter-title {
  align-items: center;
  display: flex;
  justify-content: space-between;
  & img {
    width: 2.0rem;
    cursor: pointer;
  }
}

button {
  margin-right: 1.6rem;
  text-align: left;
  &.button-block {
    display: block;
  }
}

</style>